import useMonolithApiMutation from '@/hooks/api/useMonolithApiMutation';
import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';
import { defaultRequestTransformer } from '@/utils/api';
import { accountMetadataPath } from '@/utils/monolithApiRouteService';

export type UpdateUserMetadataRequest = Record<string, null | undefined | string | number | string[] | boolean>;

interface UseMetadataOptions {
  onError?: () => void;
  onSuccess?: () => void;
  transform?: boolean;
}

export const useUserMetadata = <T>(key: string, opts: UseMetadataOptions) => {
  const { data, ...rest } = useMonolithApiQuery<{ value: T }, unknown>(['usermetadata', key], accountMetadataPath(), {
    requestConfig: { params: { key } },
    ...opts,
  });

  return {
    data: data?.value,
    ...rest,
  };
};

const noTransformConfig = {
  transformRequest: defaultRequestTransformer,
};

export const useMutateUserMetadata = (opts: UseMetadataOptions = {}) => {
  const { onSuccess, onError, transform = true } = opts;

  return useMonolithApiMutation<unknown, unknown, UpdateUserMetadataRequest>(accountMetadataPath(), 'put', {
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      if (onError) {
        onError();
      }
    },
    requestConfig: transform ? undefined : noTransformConfig,
  });
};
